export default __webpack_public_path__ + "static/media/tag16.04f33ee7.svg";